import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Yellow accent bar */}
      <div className="h-1 bg-[#FFD700]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_france-directory-1/artifacts/jw82cofi_Partenaire-des-entreprises-logo-transparent.png" 
                alt="Partenaire des Entreprises"
                className="h-24 w-auto"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              L'annuaire professionnel de référence pour trouver entreprises et artisans partout en France.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/recherche" className="text-slate-400 hover:text-white text-sm">
                  Rechercher
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-slate-400 hover:text-white text-sm">
                  Catégories
                </Link>
              </li>
              <li>
                <Link to="/departements" className="text-slate-400 hover:text-white text-sm">
                  Départements
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-lg mb-4">Catégories populaires</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/recherche?category=plomberie" className="text-slate-400 hover:text-white text-sm">
                  Plomberie
                </Link>
              </li>
              <li>
                <Link to="/recherche?category=electricite" className="text-slate-400 hover:text-white text-sm">
                  Électricité
                </Link>
              </li>
              <li>
                <Link to="/recherche?category=restaurant" className="text-slate-400 hover:text-white text-sm">
                  Restaurants
                </Link>
              </li>
              <li>
                <Link to="/recherche?category=medecin" className="text-slate-400 hover:text-white text-sm">
                  Médecins
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-[#FFD700]" />
                Paris, France
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-[#FFD700]" />
                09 72 22 59 14
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-[#FFD700]" />
                contact@partenairedesentreprises.fr
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Partenaire des Entreprises. Tous droits réservés.
          </p>
          <div className="flex gap-4">
            <Link to="#" className="text-slate-500 hover:text-white text-sm">
              Mentions légales
            </Link>
            <Link to="#" className="text-slate-500 hover:text-white text-sm">
              Politique de confidentialité
            </Link>
            <Link to="#" className="text-slate-500 hover:text-white text-sm">
              CGU
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
